import * as React from 'react';
import * as Cx from 'classnames';
import { Link, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { questions, Question, Topic } from '../data/questions';
import './questions.css';

const questionsBackground = {
  backgroundImage: `url(${process.env.PUBLIC_URL + '/img/questions_background.jpg'})`,
};

export default class QuestionsPage extends React.PureComponent<RouteComponentProps<{}>, {}> {
  questionMenuTopic = (topic: Topic): JSX.Element[] => {
    return [
      <p key={`${topic.topic}-topic`} className="menu-label">
        {topic.topic}
      </p>,
      <ul key={`${topic.topic}-list`} className="menu-list">
        {topic.questions.map(this.questionMenuQuestion)}
      </ul>,
    ];
  };

  questionMenuQuestion = ({ path, question }: Question): JSX.Element => {
    return (
      <li key={question}>
        <Link
          to={path}
          className={Cx({
            'is-active': this.props.location.pathname === path,
          })}
        >
          {question}
        </Link>
      </li>
    );
  };

  questionInfo(question: Question): () => JSX.Element {
    return () => (
      <div className="question-info content">
        <h1>{question.question}</h1>
        <p>{question.answer}</p>
        {question.link ? (
          <p>
            <Link to={question.link}>{question.linkText}</Link>
          </p>
        ) : null}
        <Link to="/questions" className="is-hidden-tablet back-to-menu">
          <i className="fa fa-chevron-left" /> Back to questions
        </Link>
      </div>
    );
  }

  get questionListRoutes(): JSX.Element[] {
    return questions.reduce(
      (agg1, topic) => {
        return agg1.concat(
          topic.questions.reduce(
            (agg2, question) => {
              agg2.push(<Route key={question.path} path={question.path} render={this.questionInfo(question)} />);
              return agg2;
            },
            [] as JSX.Element[],
          ),
        );
      },
      [] as JSX.Element[],
    );
  }

  menu = (): JSX.Element => {
    return (
      <div>
        <nav className="menu">{questions.map(this.questionMenuTopic)}</nav>
      </div>
    );
  };

  desktopRoot = (): JSX.Element => {
    return (
      <div className="question-info content">
        <h1>You got questions? We got answers!</h1>
      </div>
    );
  };

  render(): JSX.Element {
    return (
      <section className="section questions background escape-nav" style={questionsBackground}>
        <h1 className="title is-shadowed has-text-centered">Questions</h1>
        <div className="container is-hidden-mobile">
          <div className="columns">
            <aside className="menu-container column is-3">{this.menu()}</aside>
            <section className="question-container column is-offset-1">
              <Switch>
                {this.questionListRoutes}
                <Route path="/questions" render={this.desktopRoot} />
              </Switch>
            </section>
          </div>
        </div>
        <div className="container is-hidden-tablet">
          <Switch>
            {this.questionListRoutes}
            <Route path="/questions" render={this.menu} />
          </Switch>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/questions.tsx